import { SerializeHTML } from "@/shared/components/SerializeHTML";

// Rend le corps du règlement servi par l'API (body_html). Aucune version du
// texte n'est embarquée côté front : le règlement provient exclusivement de
// la base (voir la migration SeedSponsorshipTermsV1).
type Props = { bodyHtml: string };

export const SponsorshipTermsContent = ({ bodyHtml }: Props) => (
  <SerializeHTML
    htmlContent={bodyHtml}
    className="reglement-content"
  />
);

SponsorshipTermsContent.displayName = "SponsorshipTermsContent";
